import cheninBlancImg from "../../../images/wineBottles/CheninBlanc.png";
import cheninCrianzaImg from "../../../images/wineBottles/CheninCrianza.png";
import conchaLolaCheninImg from "../../../images/wineBottles/ConchaChenin.png";
import conchaLolaEspumosoRoseImg from "../../../images/wineBottles/ConchaEspumoso.png";
import granCanarioImg from "../../../images/wineBottles/GranCanario.png";
import inizioImg from "../../../images/wineBottles/Inizio.png";
import sierraInyaaImg from "../../../images/wineBottles/Inyaa.png";
import merlotImg from "../../../images/wineBottles/Merlot.png";
import rose9Img from "../../../images/wineBottles/Rose9.png";
import sierraMonarcaImg from "../../../images/wineBottles/SierraMonarca.png";
import sierraNegraImg from "../../../images/wineBottles/SierraNegra.png";
import sierraRealImg from "../../../images/wineBottles/SierraReal.png";

const AMAZON_STORE_URL =
  "https://www.amazon.com.mx/s?me=A1TPZV9LIMUF1L&marketplaceID=A1AM78C64UM0Y8";

export const wines = [
  {
    id: "gran-canario",
    name: "Gran Canario",
    type: "White Wine",
    price: "",
    cont: "750",
    stock: "6",
    alcoholVol: "13",
    descriptionEN:
      "White wine made with Palomino from Valle de Guadalupe, with barrel aging that adds depth.",
    descriptionES:
      "Vino blanco de Palomino del Valle de Guadalupe, con crianza en barrica que aporta mayor profundidad.",
    temp: "8-10",
    noseEN: "Honey, syrup and dried nuts.",
    noseES: "Miel, almíbar y frutos secos.",
    colorEN: "Bright golden color with copper highlights.",
    colorES: "Color dorado brillante con destellos cobrizos.",
    mouthEN: "Semi-dry with good acidity.",
    mouthES: "Semiseco con buena acidez.",
    pairingEN: "Seafood, creamy cheeses and dishes with buttery sauces.",
    pairingES: "Mariscos, quesos cremosos y platillos con salsas untuosas.",
    image: granCanarioImg,
    amazonUrl:
      "https://www.amazon.com.mx/Blanco-Sierra-Vita-Canario-Palomino/dp/B0D92QD8Z2",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-blanco-sierra-vita-gran-canario-palomino-750-ml/p/MLM38200570",
  },
  {
    id: "sierra-monarca",
    name: "Sierra Monarca",
    type: "Red Blend",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "13",
    descriptionEN:
      "Bordeaux-style red blend made with Cabernet Sauvignon, Cabernet Franc, Malbec and Merlot, aged in oak.",
    descriptionES:
      "Mezcla bordelesa elaborada con Cabernet Sauvignon, Cabernet Franc, Malbec y Merlot, con crianza en roble.",
    temp: "18",
    noseEN:
      "Cherry, raspberry, blackberry, currant, black plum, black pepper, vanilla, cinnamon and licorice.",
    noseES:
      "Cereza, frambuesa, mora, grosella, ciruela negra, pimienta negra, vainilla, canela y regaliz.",
    colorEN: "Deep ruby red with terracotta tones.",
    colorES: "Rojo rubí profundo con tonalidades terracota.",
    mouthEN:
      "Dry, medium to full body, balanced acidity, soft tannins, complex and elegant.",
    mouthES:
      "Seco, de cuerpo medio a completo, acidez equilibrada, taninos suaves, complejo y elegante.",
    pairingEN: "Lamb, beef ribs, premium cuts, red meats and aged cheeses.",
    pairingES:
      "Borrego, costillas de res, cortes finos, carnes rojas y quesos maduros.",
    image: sierraMonarcaImg,
    amazonUrl:
      "https://www.amazon.com.mx/Sierra-Vita-Monarca-Vino-Tinto/dp/B0DPJ89R35",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-tinto-mezcla-bordelesa-sierra-monarca-sierra-vita-750ml/up/MLMU3131666718",
  },
  {
    id: "concha-lola-rose",
    name: "Concha & Lola Rosé Espumoso",
    type: "Sparkling Rosé",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "13",
    descriptionEN:
      "Sparkling rosé made with Grenache, Cabernet Sauvignon, Nebbiolo and French Colombard.",
    descriptionES:
      "Vino rosado espumoso elaborado con Grenache, Cabernet Sauvignon, Nebbiolo y French Colombard.",
    temp: "6-8",
    noseEN: "Red berries, strawberry, mandarin, citrus and caramel.",
    noseES: "Frutos rojos, fresa, mandarina, cítricos y caramelo.",
    colorEN: "Bright salmon pink with fine bubbles.",
    colorES: "Rosa salmón brillante con burbuja fina.",
    mouthEN: "Marked creaminess; red fruit flavors and a citrus finish.",
    mouthES: "Untuosidad marcada; sabores de frutos rojos y final cítrico.",
    pairingEN: "Mexican dishes or enjoyed on its own, very cold.",
    pairingES: "Platillos mexicanos o para disfrutarse solo, bien frío.",
    image: conchaLolaEspumosoRoseImg,
    amazonUrl:
      "https://www.amazon.com.mx/Sierra-Vita-Casa-Vinicola-Guadalupe/dp/B0FFY19QQD",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl: "",
  },
  {
    id: "concha-lola-chenin",
    name: "Concha & Lola Chenin Blanc",
    type: "White Wine",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "",
    descriptionEN:
      "A fresh white blend of Chenin Blanc and Palomino with a soft and approachable character.",
    descriptionES:
      "Ensamblaje blanco fresco de Chenin Blanc y Palomino, con carácter amable y fácil de disfrutar.",
    temp: "8-10",
    noseEN: "Citrus, orchard fruit and soft floral notes.",
    noseES: "Cítricos, fruta de huerto y notas florales suaves.",
    colorEN: "Pale straw yellow color with bright highlights.",
    colorES: "Color amarillo paja pálido con destellos brillantes.",
    mouthEN: "Fresh entry, light body and crisp finish.",
    mouthES: "Entrada fresca, cuerpo ligero y final limpio.",
    pairingEN:
      "Fresh seafood, grilled fish, citrus salads and soft goat cheeses.",
    pairingES:
      "Mariscos frescos, pescados a la parrilla, ensaladas con cítricos y quesos suaves de cabra.",
    image: conchaLolaCheninImg,
    amazonUrl: "",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-blanco-chenin-blancpalomino-conchalola-sierra-vita/up/MLMU3168327731",
  },
  {
    id: "chenin-blanc-crianza",
    name: "Chenin Blanc Crianza",
    type: "White Wine",
    price: "909",
    cont: "750",
    stock: "4",
    alcoholVol: "13",
    descriptionEN:
      "Barrel-aged Chenin Blanc with a richer profile and added texture.",
    descriptionES:
      "Chenin Blanc con crianza en barrica, de perfil más amplio y con mayor textura.",
    temp: "10",
    noseEN: "Citrus, green apple, honey and vanilla.",
    noseES: "Cítricos, manzana verde, miel y vainilla.",
    colorEN: "Golden yellow color with warm reflections.",
    colorES: "Color amarillo dorado con reflejos cálidos.",
    mouthEN: "Round texture with balanced acidity and a lightly creamy finish.",
    mouthES:
      "Textura redonda con acidez equilibrada y final ligeramente cremoso.",
    pairingEN: "Seafood, chicken and cheeses with acidic notes.",
    pairingES: "Comida del mar, pollo y quesos con notas ácidas.",
    image: cheninCrianzaImg,
    amazonUrl: "",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-blanco-sierra-vita-chenin-blanc-crianza-750-ml/up/MLMU484371612",
  },
  {
    id: "chenin-blanc",
    name: "Chenin Blanc",
    type: "White Wine",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "",
    descriptionEN:
      "Fresh and balanced white wine made to express the identity of Valle de Guadalupe.",
    descriptionES:
      "Vino blanco fresco y equilibrado, elaborado para expresar la identidad del Valle de Guadalupe.",
    temp: "8-10",
    noseEN: "Fresh citrus, white fruit and soft floral notes.",
    noseES: "Cítricos frescos, fruta blanca y notas florales suaves.",
    colorEN: "Pale yellow color with greenish highlights.",
    colorES: "Color amarillo pálido con reflejos verdosos.",
    mouthEN: "Light body, bright acidity and refreshing finish.",
    mouthES: "Cuerpo ligero, acidez viva y final refrescante.",
    pairingEN: "Seafood, salads, light pasta dishes and fresh cheeses.",
    pairingES: "Mariscos, ensaladas, pastas ligeras y quesos frescos.",
    image: cheninBlancImg,
    amazonUrl: "",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-blanco-sierra-vita-chenin-blanc-750-ml/p/MLM29265598",
  },
  {
    id: "inizio",
    name: "Inizio",
    type: "Red Blend",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "13.7",
    descriptionEN:
      "Red blend from Valle de Guadalupe made from Shiraz/Syrah, Cabernet Sauvignon, Merlot and Tempranillo.",
    descriptionES:
      "Vino tinto ensamblaje del Valle de Guadalupe elaborado con Shiraz/Syrah, Cabernet Sauvignon, Merlot y Tempranillo.",
    temp: "16-18",
    noseEN: "Wild berries, vanilla and a light cocoa note.",
    noseES: "Frutos silvestres, vainilla y una ligera nota de cacao.",
    colorEN: "Intense red color with violet hues.",
    colorES: "Color rojo intenso con matices violáceos.",
    mouthEN:
      "Cherry, plum and dill flavors with good persistence and balanced acidity.",
    mouthES:
      "Sabores a cereza, ciruela y eneldo, con buena permanencia y acidez equilibrada.",
    pairingEN: "Roasted meats, pasta with red sauce and aged cheeses.",
    pairingES: "Carnes asadas, pastas con salsa roja y quesos maduros.",
    image: inizioImg,
    amazonUrl: "",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-tinto-mezcla-inizio-sierra-vita-valle-de-guadalupe/p/MLM50414228",
  },
  {
    id: "sierra-inyaa",
    name: "Sierra Inyaa",
    type: "Red Wine",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "13",
    descriptionEN:
      "Red wine from Valle de Guadalupe made with Shiraz/Syrah, expressive and fruit-forward.",
    descriptionES:
      "Vino tinto del Valle de Guadalupe elaborado con Shiraz/Syrah, expresivo y con perfil frutal.",
    temp: "16-18",
    noseEN: "Dark fruit, black pepper and soft spice notes typical of Syrah.",
    noseES:
      "Fruta negra, pimienta negra y notas especiadas suaves típicas del Syrah.",
    colorEN: "Deep ruby color with violet reflections.",
    colorES: "Color rojo rubí profundo con reflejos violáceos.",
    mouthEN: "Juicy texture, medium body and a spicy finish.",
    mouthES: "Textura jugosa, cuerpo medio y final especiado.",
    pairingEN: "Beef, lamb, poultry and game.",
    pairingES: "Res, cordero, aves y carne de caza.",
    image: sierraInyaaImg,
    amazonUrl: "",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-tinto-mexicano-sierra-inyaa-sierra-vita-valle-de-gpe/up/MLMU3129076139",
  },
  {
    id: "sierra-negra",
    name: "Sierra Negra",
    type: "Red Wine",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "",
    descriptionEN:
      "Malbec-based red wine from Valle de Guadalupe with dark fruit character.",
    descriptionES:
      "Vino tinto de Malbec del Valle de Guadalupe con perfil de fruta negra.",
    temp: "16-18",
    noseEN: "Black fruit.",
    noseES: "Frutos negros.",
    colorEN: "Ruby red with violet tones.",
    colorES: "Rojo rubí con matices violáceos.",
    mouthEN: "Soft texture, ripe fruit expression and medium body.",
    mouthES: "Textura suave, expresión de fruta madura y cuerpo medio.",
    pairingEN: "Grilled meats, burgers and medium-aged cheeses.",
    pairingES: "Carnes a la parrilla, hamburguesas y quesos semimadurados.",
    image: sierraNegraImg,
    amazonUrl:
      "https://www.amazon.com.mx/Sierra-Vita-Casa-Vinicola-Guadalupe/dp/B0DPJ98PCX",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-tinto-sierra-vita-sierra-negra-malbec-750-ml/p/MLM29272006",
  },
  {
    id: "sierra-real",
    name: "Sierra Real",
    type: "Red Wine",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "13",
    descriptionEN:
      "A Cabernet Franc-based red wine from Valle de Guadalupe with an elegant profile and structured character.",
    descriptionES:
      "Vino tinto a base de Cabernet Franc del Valle de Guadalupe, con perfil elegante y carácter estructurado.",
    temp: "16-18",
    noseEN: "Herbal notes, red fruit and light spice typical of Cabernet Franc.",
    noseES:
      "Notas herbales, fruta roja y especias ligeras típicas del Cabernet Franc.",
    colorEN: "Medium to deep ruby red color.",
    colorES: "Color rojo rubí de intensidad media a profunda.",
    mouthEN: "Balanced acidity with fine tannins and a fresh, refined finish.",
    mouthES:
      "Acidez equilibrada con taninos finos y un final fresco y refinado.",
    pairingEN: "Roasted meats, grilled vegetables and semi-aged cheeses.",
    pairingES: "Carnes asadas, vegetales a la parrilla y quesos semimadurados.",
    image: sierraRealImg,
    amazonUrl:
      "https://www.amazon.com.mx/Tinto-Sierra-Vita-Cabernet-Franc/dp/B0D92RB9FQ",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl:
      "https://www.mercadolibre.com.mx/vino-tinto-mexicano-sierra-real-sierra-vita-750ml/up/MLMU3134492090",
  },
  {
    id: "merlot",
    name: "Merlot",
    type: "Red Wine",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "",
    descriptionEN:
      "Merlot-based red wine with a soft texture and approachable fruit profile.",
    descriptionES:
      "Vino tinto de Merlot con textura suave y perfil frutal fácil de disfrutar.",
    temp: "16-18",
    noseEN: "Ripe red fruit, plum and soft spice.",
    noseES: "Fruta roja madura, ciruela y especias suaves.",
    colorEN: "Ruby red color.",
    colorES: "Color rojo rubí.",
    mouthEN: "Smooth body, ripe fruit and gentle tannins.",
    mouthES: "Cuerpo suave, fruta madura y taninos amables.",
    pairingEN: "Pasta, roasted chicken and semi-aged cheeses.",
    pairingES: "Pastas, pollo rostizado y quesos semimadurados.",
    image: merlotImg,
    amazonUrl: "",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl: "",
  },
  {
    id: "rose-9",
    name: "Rosé 9",
    type: "Rosé",
    price: "",
    cont: "750",
    stock: "",
    alcoholVol: "",
    descriptionEN: "Fresh rosé wine with a bright and easy-drinking profile.",
    descriptionES:
      "Vino rosado fresco con perfil brillante y fácil de disfrutar.",
    temp: "8-10",
    noseEN: "Fresh berries, floral notes and citrus hints.",
    noseES: "Frutos rojos frescos, notas florales y toques cítricos.",
    colorEN: "Soft pink color.",
    colorES: "Color rosa suave.",
    mouthEN: "Refreshing acidity and light body.",
    mouthES: "Acidez refrescante y cuerpo ligero.",
    pairingEN: "Salads, seafood and light appetizers.",
    pairingES: "Ensaladas, mariscos y aperitivos ligeros.",
    image: rose9Img,
    amazonUrl: "",
    fallbackAmazonUrl: AMAZON_STORE_URL,
    mercadoLibreUrl: "",
  },
];